import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { api } from './api';
const PERSONA_TEXT = [['ageRange', 'Age range', 'e.g. 30-39'], ['education', 'Education', 'e.g. BSc Civil Engineering, UNILAG'], ['language', 'Language', 'e.g. English, with occasional Pidgin'], ['tone', 'Tone', 'e.g. warm, practical, a bit wry'], ['style', 'Communication style', 'How it writes: asks questions, uses examples, short paragraphs…'], ['disagreement', 'When it disagrees', 'e.g. respectful, gives reasons and a source'], ['geoInterests', 'Places it follows', 'e.g. Lagos, Ontario, Kano'], ['avoid', 'Topics it avoids', 'e.g. religion, party politics'], ['dailyMax', 'Posts per day at most', 'Blank = site-wide limit']];
const PERSONA_LISTS = [['primaryInterests', 'Main interests'], ['secondaryInterests', 'Other interests'], ['expertise', 'Professional expertise']];
const CHOICES = {
  formality: ['Formality', [['casual', 'Casual'], ['neutral', 'Neutral'], ['formal', 'Formal']]],
  length: ['Usual length', [['short', 'Short'], ['medium', 'Medium'], ['long', 'Long']]],
  detail: ['Level of detail', [['light', 'Light'], ['balanced', 'Balanced'], ['detailed', 'Detailed']]]
};
const TYPE_LABELS = {
  core: 'Core',
  conversation: 'Conversation',
  evolving: 'Evolving'
};
const KIND_LABELS = {
  fact: 'Fact',
  opinion: 'Opinion',
  background: 'Fictional background'
};
function toForm(p) {
  const f = {
    memoryEnabled: p.memoryEnabled !== false,
    tagIds: p.tagIds || []
  };
  PERSONA_TEXT.forEach(_ref => {
    let [k] = _ref;
    return f[k] = p[k] || '';
  });
  PERSONA_LISTS.forEach(_ref2 => {
    let [k] = _ref2;
    return f[k] = (p[k] || []).join(', ');
  });
  Object.keys(CHOICES).forEach(k => f[k] = p[k] || '');
  f.background = p.background || '';
  return f;
}

/** Personas: settings and memory for one managed account at a time. attrs: state */
export default class PersonasTab extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.data = null;
    this.form = null;
    this.filter = 'all';
    this.busy = {};
    this.newMemory = {
      type: 'core',
      kind: 'fact',
      content: ''
    };
    this.editing = null;
    this.preview = {
      text: '',
      result: null
    };
    const s = this.attrs.state;
    if (!s.selected && s.accounts && s.accounts.length) s.selected = s.accounts[0].userId;
    this.loadedFor = null;
  }
  onbeforeupdate() {
    this.ensureLoaded();
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.ensureLoaded();
  }
  ensureLoaded() {
    const id = this.attrs.state.selected;
    if (id && id !== this.loadedFor) {
      this.loadedFor = id;
      this.data = null;
      this.form = null;
      api('GET', '/personas/' + id).then(r => {
        this.data = r;
        this.form = toForm(r.persona || {});
      }).catch(() => this.data = {
        error: true
      }).finally(() => m.redraw());
    }
  }
  run(key, promise) {
    this.busy[key] = true;
    m.redraw();
    return promise.catch(() => {}).finally(() => {
      this.busy[key] = false;
      m.redraw();
    });
  }
  view() {
    const s = this.attrs.state;
    const accounts = s.accounts || [];
    if (!accounts.length) return m("p", {
      className: "VEC-empty"
    }, "Add an account first.");
    if (!accounts.some(a => a.userId === s.selected)) {
      s.selected = accounts[0].userId;
      setTimeout(() => this.ensureLoaded(), 0);
    }
    const current = accounts.find(a => a.userId === s.selected);
    return m("div", {
      className: "VEC-personas"
    }, m("div", {
      className: "VEC-card VEC-as"
    }, m("label", {
      className: "VEC-field"
    }, m("span", null, "Account"), m("select", {
      className: "FormControl",
      value: s.selected || '',
      onchange: e => {
        s.selected = parseInt(e.target.value, 10) || null;
      }
    }, accounts.map(a => m("option", {
      value: a.userId
    }, a.displayName, " (@", a.username, ")", a.status === 'paused' ? ' — paused' : ''))))), !current ? null : !this.data || !this.form ? m(LoadingIndicator, null) : this.data.error ? m("p", {
      className: "VEC-empty"
    }, "Couldn't load this account.") : [this.personaForm(current), this.memoryPanel(current)]);
  }
  personaForm(a) {
    const f = this.form;
    const tags = (app.store.all('tags') || []).filter(t => !(t.isHidden && t.isHidden())).sort((x, y) => x.name().localeCompare(y.name()));
    return m("form", {
      className: "VEC-card",
      onsubmit: e => {
        e.preventDefault();
        this.savePersona(a);
      }
    }, m("div", {
      className: "VEC-row-head"
    }, m("h3", null, "Persona"), m(Button, {
      className: "Button",
      icon: "fas fa-magic",
      loading: this.busy.draft,
      disabled: !s_aiReady(this.attrs.state),
      onclick: () => this.draft(a)
    }, "Suggest with AI")), m("p", {
      className: "VEC-help"
    }, "How ", a.displayName, " writes. Location, origin, profession and study come from its My Community answers (Accounts > Edit)."), m("div", {
      className: "VEC-fields"
    }, PERSONA_TEXT.map(_ref3 => {
      let [k, label, hint] = _ref3;
      return m("label", {
        className: "VEC-field"
      }, m("span", null, label), m("input", {
        className: "FormControl",
        value: f[k],
        placeholder: hint,
        oninput: e => f[k] = e.target.value
      }));
    }), Object.keys(CHOICES).map(k => m("label", {
      className: "VEC-field"
    }, m("span", null, CHOICES[k][0]), m("select", {
      className: "FormControl",
      value: f[k],
      onchange: e => f[k] = e.target.value
    }, m("option", {
      value: ""
    }, "Not set"), CHOICES[k][1].map(_ref4 => {
      let [v, l] = _ref4;
      return m("option", {
        value: v
      }, l);
    })))), PERSONA_LISTS.map(_ref5 => {
      let [k, label] = _ref5;
      return m("label", {
        className: "VEC-field"
      }, m("span", null, label), m("input", {
        className: "FormControl",
        value: f[k],
        placeholder: "Comma-separated",
        oninput: e => f[k] = e.target.value
      }));
    }), m("label", {
      className: "VEC-field is-wide"
    }, m("span", null, "Fictional background"), m("textarea", {
      className: "FormControl",
      rows: "3",
      value: f.background,
      placeholder: "A few sentences the AI can draw on. It's treated as background, never stated as real events.",
      oninput: e => f.background = e.target.value
    })), m("div", {
      className: "VEC-field is-wide"
    }, m("span", null, "Preferred tags"), m("div", {
      className: "VEC-tags"
    }, tags.map(t => {
      const on = f.tagIds.includes(Number(t.id()));
      return m("button", {
        type: "button",
        className: 'VEC-tag' + (on ? ' is-on' : ''),
        onclick: () => f.tagIds = on ? f.tagIds.filter(x => x !== Number(t.id())) : [...f.tagIds, Number(t.id())]
      }, t.name());
    }))), m("label", {
      className: "VEC-check is-wide"
    }, m("input", {
      type: "checkbox",
      checked: f.memoryEnabled,
      onchange: e => f.memoryEnabled = e.target.checked
    }), " Keep memory for this account (its published posts are remembered)")), m("div", {
      className: "VEC-actions"
    }, m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.busy.save
    }, "Save persona")));
  }
  draft(a) {
    this.run('draft', api('POST', '/personas/' + a.userId + '/draft').then(r => {
      const keep = {
        memoryEnabled: this.form.memoryEnabled,
        tagIds: this.form.tagIds
      };
      this.form = Object.assign(toForm(r.persona || {}), keep);
      app.alerts.show({
        type: 'success'
      }, 'Suggestion filled in. Review it, then Save persona.');
    }));
  }
  savePersona(a) {
    this.run('save', api('POST', '/personas/' + a.userId, {
      persona: this.form
    }).then(r => {
      this.data = r;
      this.form = toForm(r.persona || {});
      app.alerts.show({
        type: 'success'
      }, 'Persona saved.');
    }));
  }
  memoryPanel(a) {
    const d = this.data;
    const c = d.counts || {};
    const list = (d.memories || []).filter(x => this.filter === 'all' || (this.filter === 'flagged' ? x.flagged : x.type === this.filter));
    const filters = [['all', 'All'], ['core', 'Core ' + (c.core || 0)], ['conversation', 'Conversation ' + (c.conversation || 0)], ['evolving', 'Evolving ' + (c.evolving || 0)], ['flagged', 'Flagged ' + (c.flagged || 0)]];
    const aiReady = s_aiReady(this.attrs.state);
    return m("div", {
      className: "VEC-card VEC-memory"
    }, m("div", {
      className: "VEC-row-head"
    }, m("h3", null, "Memory"), m("div", {
      className: "VEC-actions"
    }, m(Button, {
      className: "Button",
      icon: "fas fa-download",
      loading: this.busy.import,
      onclick: () => this.action(a, 'import', null, r => r.imported + ' past posts added.')
    }, "Import past posts"), m(Button, {
      className: "Button",
      icon: "fas fa-seedling",
      loading: this.busy.evolve,
      disabled: !aiReady,
      onclick: () => this.action(a, 'evolve', null, r => r.read ? 'Read ' + r.read + ' posts: ' + r.added + ' new memories, ' + r.flagged + ' flagged.' : 'No new posts to learn from.')
    }, "Update evolving memory"), m(Button, {
      className: "Button",
      icon: "fas fa-compress-alt",
      loading: this.busy.summarise,
      disabled: !aiReady,
      onclick: () => this.action(a, 'summarise', null, r => r.summarised ? r.summarised + ' older items summarised into ' + r.into + '.' : 'Not enough older memory to summarise yet.')
    }, "Summarise older"))), m("p", {
      className: "VEC-help"
    }, m("strong", null, "Core"), ": who it is. ", m("strong", null, "Conversation"), ": what it has posted (added automatically when a post is published, so drafts never count).", ' ', m("strong", null, "Evolving"), ": views and things learned, read from its posts by the AI. Possible contradictions are flagged for you to settle."), m("div", {
      className: "VEC-filters"
    }, filters.map(_ref6 => {
      let [k, l] = _ref6;
      return m(Button, {
        className: 'Button Button--text' + (this.filter === k ? ' is-active' : ''),
        onclick: () => this.filter = k
      }, l);
    })), m("form", {
      className: "VEC-memory-add",
      onsubmit: e => {
        e.preventDefault();
        this.addMemory(a);
      }
    }, m("select", {
      className: "FormControl",
      value: this.newMemory.type,
      onchange: e => this.newMemory.type = e.target.value
    }, Object.keys(TYPE_LABELS).map(k => m("option", {
      value: k
    }, TYPE_LABELS[k]))), m("select", {
      className: "FormControl",
      value: this.newMemory.kind,
      onchange: e => this.newMemory.kind = e.target.value
    }, Object.keys(KIND_LABELS).map(k => m("option", {
      value: k
    }, KIND_LABELS[k]))), m("input", {
      className: "FormControl",
      value: this.newMemory.content,
      placeholder: "Add something to remember\u2026",
      oninput: e => this.newMemory.content = e.target.value
    }), m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.busy.add
    }, "Add")), list.length ? m("ul", {
      className: "VEC-memlist"
    }, list.map(x => this.memoryRow(a, x))) : m("p", {
      className: "VEC-empty"
    }, "Nothing here yet."), m("div", {
      className: "VEC-preview"
    }, m("h4", null, "What would the AI recall?"), m("p", {
      className: "VEC-help"
    }, "Paste a discussion title or text to see which memories it would get when writing about it."), m("div", {
      className: "VEC-memory-add"
    }, m("input", {
      className: "FormControl",
      value: this.preview.text,
      placeholder: "e.g. Rent in Toronto is getting out of hand",
      oninput: e => this.preview.text = e.target.value
    }), m(Button, {
      className: "Button",
      loading: this.busy.preview,
      onclick: () => this.run('preview', api('POST', '/personas/' + a.userId + '/memory/preview', {
        text: this.preview.text
      }).then(r => this.preview.result = r.memories || []))
    }, "Check")), this.preview.result ? this.preview.result.length ? m("ol", {
      className: "VEC-recall"
    }, this.preview.result.map(r => m("li", null, m("span", {
      className: "VEC-pill"
    }, TYPE_LABELS[r.type]), " ", r.content))) : m("p", {
      className: "VEC-help"
    }, "No memories yet.") : null), m("div", {
      className: "VEC-reset"
    }, m("span", {
      className: "VEC-muted"
    }, "Reset memory:"), ['conversation', 'evolving', 'core', 'all'].map(t => m(Button, {
      className: "Button Button--text",
      onclick: () => this.reset(a, t)
    }, t === 'all' ? 'Everything' : TYPE_LABELS[t]))));
  }
  memoryRow(a, x) {
    const editing = this.editing && this.editing.id === x.id;
    return m("li", {
      className: 'VEC-mem' + (x.flagged ? ' is-flagged' : ''),
      key: x.id
    }, m("div", {
      className: "VEC-mem-meta"
    }, m("span", {
      className: "VEC-pill"
    }, TYPE_LABELS[x.type]), m("span", {
      className: 'VEC-pill is-' + x.kind
    }, KIND_LABELS[x.kind]), x.discussionId ? m("a", {
      className: "VEC-muted",
      href: '/d/' + x.discussionId,
      target: "_blank",
      rel: "noopener"
    }, "source") : null, m("span", {
      className: "VEC-muted"
    }, String(x.at).slice(0, 10))), x.flagged ? m("div", {
      className: "VEC-flag"
    }, m("i", {
      className: "fas fa-flag"
    }), " ", x.flagReason || 'Flagged for review', " ", m(Button, {
      className: "Button Button--text",
      onclick: () => this.saveMemory(a, x.id, {
        flagged: false
      })
    }, "Mark as fine")) : null, editing ? m("div", {
      className: "VEC-memory-add"
    }, m("textarea", {
      className: "FormControl",
      rows: "2",
      value: this.editing.content,
      oninput: e => this.editing.content = e.target.value
    }), m(Button, {
      className: "Button Button--primary",
      onclick: () => this.saveMemory(a, x.id, {
        content: this.editing.content,
        flagged: false
      }).then(() => this.editing = null)
    }, "Save"), m(Button, {
      className: "Button",
      onclick: () => this.editing = null
    }, "Cancel")) : m("div", {
      className: "VEC-mem-text"
    }, x.content), !editing ? m("div", {
      className: "VEC-mem-actions"
    }, m(Button, {
      className: "Button Button--text",
      onclick: () => this.editing = {
        id: x.id,
        content: x.content
      }
    }, "Edit"), m(Button, {
      className: "Button Button--text",
      onclick: () => this.deleteMemory(a, x.id)
    }, "Delete")) : null);
  }
  apply(r) {
    if (r && r.memories) this.data.memories = r.memories;
    if (r && r.counts) this.data.counts = r.counts;
  }
  addMemory(a) {
    this.run('add', api('POST', '/personas/' + a.userId + '/memories', this.newMemory).then(r => {
      this.apply(r);
      this.newMemory.content = '';
    }));
  }
  saveMemory(a, id, changes) {
    return api('POST', '/personas/' + a.userId + '/memories/' + id, changes).then(r => this.apply(r)).catch(() => {}).finally(() => m.redraw());
  }
  deleteMemory(a, id) {
    api('DELETE', '/personas/' + a.userId + '/memories/' + id).then(r => this.apply(r)).catch(() => {}).finally(() => m.redraw());
  }
  action(a, name, body, message) {
    this.run(name, api('POST', '/personas/' + a.userId + '/memory/' + name, body || {}).then(r => {
      app.alerts.show({
        type: 'success'
      }, message(r));
      return this.reload(a);
    }));
  }
  reset(a, type) {
    const what = type === 'all' ? 'all memory' : (TYPE_LABELS[type] || type).toLowerCase() + ' memory';
    if (!window.confirm('Delete ' + what + ' for ' + a.displayName + '? This can\'t be undone.')) return;
    this.action(a, 'reset', {
      type
    }, r => r.deleted + ' memories deleted.');
  }
  reload(a) {
    return api('GET', '/personas/' + a.userId).then(r => {
      this.data.memories = r.memories;
      this.data.counts = r.counts;
    });
  }
}
function s_aiReady(state) {
  return !!(state && state.aiReady);
}